import Vue from 'vue'
import VueRouter from 'vue-router'
//import Home from '../views/Home.vue'

import Companies from '../views/Companies.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Companies
  },
  {
    path: '/register',
    name: 'register',
    component: Companies
  },
  {
    path: '/register/shopify/:shopifyStore',
    name: 'register-shopify',
    component: Companies
  },
  {
    path: '/redirect/:type/:id/:path',
    name: 'plredirect',
    component: () => import(/* webpackChunkName: "redirect" */ '../views/Redirect.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue')
  },
  {
    path: '/token/:token',
    name: 'token',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "profile" */ '../views/Token.vue')
  },
  {
    path: '/companies',
    name: 'companies',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "companies" */ '../views/Companies.vue')
  },
  {
    path: '/add-company',
    name: 'add-company',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "add-company" */ '../views/AddCompany.vue')
  },
  {
    path: '/companies/:company',
    //name: '',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "company" */ '../views/company/Index.vue'),
    children: [
      {
        name: 'domains',
        path: '', component: () => import(/* webpackChunkName: "domains" */ '../views/company/Domains.vue'),
      },
      {
        name: 'company-access',
        path: 'access', component: () => import(/* webpackChunkName: "company-access" */ '../views/company/Access.vue'),
      },
      {
        name: 'billing',
        path: 'billing', component: () => import(/* webpackChunkName: "billing" */ '../views/company/Billing.vue'),
      },
      {
        name: 'plan',
        path: 'plan', component: () => import(/* webpackChunkName: "billing" */ '../views/company/Plan.vue'),
      },
      {
        name: 'business',
        path: 'business', component: () => import(/* webpackChunkName: "business" */ '../views/company/Business.vue'),
      },
      {
        name: 'add-domain',
        path: 'add-domain', component: () => import(/* webpackChunkName: "add-domain" */ '../views/company/AddDomain.vue'),
      },
    ]
  },
  {
    path: '/companies/:company/domains/:domain',
    //name: 'domain',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "domain" */ '../views/domain/Index.vue'),
    children: [
      {
        name: 'domain-dashboard',
        path: '', component: () => import(/* webpackChunkName: "domain-dashboard" */ '../views/domain/Dashboard.vue'),
      },
      {
        name: 'domain-overview',
        path: 'setup/overview', component: () => import(/* webpackChunkName: "feeds" */ '../views/domain/overview/Index.vue'),
        children: [
          {
            name: 'contact-import',
            path: 'contact-import',
            meta: { dialog: true },
            component: () => import(/* webpackChunkName: "import-contacts" */ '../views/domain/contacts/ContactImport.vue')
          },
          {
            name: 'order-import',
            path: 'order-import',
            meta: { dialog: true },
            component: () => import(/* webpackChunkName: "import-orders" */ '../views/domain/contacts/OrderImport.vue')
          }
        ]
      },
      {
        name: 'feeds',
        path: 'setup/feeds', component: () => import(/* webpackChunkName: "feeds" */ '../views/domain/Feeds.vue'),
      },
      {
        name: 'feeds-shopify',
        path: 'setup/feeds/shopify/verify', component: () => import(/* webpackChunkName: "feeds-shopify" */ '../views/domain/Feeds.vue'),
      },
      {
        name: 'integrations',
        path: 'setup/integrations', component: () => import(/* webpackChunkName: "integrations" */ '../views/domain/Integrations.vue'),
      },
      {
        name: 'tracking',
        path: 'setup/tracking', component: () => import(/* webpackChunkName: "tracking" */ '../views/domain/tracking/Index.vue'),
        children: [
          {
            name: 'tracking-dynamic',
            path: 'dynamic/:platform', redirect: to => { return { name: `tracking-${to.params.platform}` } }
          },
          {
            name: 'tracking-shoptet',
            path: 'shoptet', component: () => import(/* webpackChunkName: "tracking-shoptet" */ '../views/domain/tracking/Shoptet.vue'),
          },
          {
            name: 'tracking-shopify',
            path: 'shopify', component: () => import(/* webpackChunkName: "tracking-shopify" */ '../views/domain/tracking/Shopify.vue'),
          },
          {
            name: 'tracking-exitshop',
            path: 'exitshop', component: () => import(/* webpackChunkName: "tracking-exitshop" */ '../views/domain/tracking/ExitShop.vue'),
          },
          {
            name: 'tracking-woocommerce',
            path: 'woocommerce', component: () => import(/* webpackChunkName: "tracking-woocommerce" */ '../views/domain/tracking/WooCommerce.vue'),
          },
          {
            name: 'tracking-other',
            path: 'other', component: () => import(/* webpackChunkName: "tracking-other" */ '../views/domain/tracking/Other.vue'),
          },
        ]
      },
      {
        path: 'webboxes/:platform?', name: 'webboxes', component: () => import(/* webpackChunkName: "webboxes" */ '../views/domain/webboxes/Index.vue'),
        
        xchildren: [
          {
            name: 'webboxes',
            path: '', redirect: 'home',
          },
          {
            name: 'webboxes-home',
            path: 'home', component: () => import(/* webpackChunkName: "webboxes-home" */ '../views/domain/webboxes/Home.vue'),
          },
          {
            name: 'webboxes-product',
            path: 'product', component: () => import(/* webpackChunkName: "webboxes-product" */ '../views/domain/webboxes/Product.vue'),
          },
          {
            name: 'webboxes-cart',
            path: 'cart', component: () => import(/* webpackChunkName: "webboxes-cart" */ '../views/domain/webboxes/Cart.vue'),
          },
          {
            name: 'webboxes-data',
            path: 'data', component: () => import(/* webpackChunkName: "webboxes-data" */ '../views/domain/webboxes/RawData.vue'),
          },
        ]
        
      },
      {
        path: 'campaigns/automatic', name: 'campaigns-automatic', component: () => import(/* webpackChunkName: "campaigns-automatic" */ '../views/domain/campaigns/Automatic.vue'),
      },
      {
        path: 'campaigns/btc', name: 'campaigns-btc', component: () => import(/* webpackChunkName: "campaigns-btc" */ '../views/domain/campaigns/BackToCart.vue'),
      },
      {
        path: 'campaigns/swu', name: 'campaigns-swu', component: () => import(/* webpackChunkName: "campaigns-swu" */ '../views/domain/campaigns/SmartWarmUp.vue'),
      },
      {
        path: 'campaigns/scheduled', name: 'campaigns-scheduled', component: () => import(/* webpackChunkName: "campaigns-scheduled" */ '../views/domain/campaigns/Scheduled.vue'),
      },
      {
        path: 'campaigns/welcome', name: 'campaigns-welcome', component: () => import(/* webpackChunkName: "campaigns-welcome" */ '../views/domain/campaigns/Welcome.vue'),
      },
      {
        path: 'campaigns/add/:type?',  component: () => import(/* webpackChunkName: "campaigns-add" */ '../views/domain/campaigns/Index.vue'),
        children: [
          {
            name: 'add-campaign',
            path: '', component: () => import(/* webpackChunkName: "campaigns-type" */ '../views/domain/campaigns/Type.vue'),
          }
        ]
      },
      {
        //name: 'camapigns',
        path: 'campaigns/:campaign', component: () => import(/* webpackChunkName: "campaigns" */ '../views/domain/campaigns/Index.vue'),
        children: [
          {
            name: 'campaign-detail',
            // TODO remove index, add detail?
            path: '', component: () => import(/* webpackChunkName: "campaign-detail" */ '../views/domain/campaigns/Detail.vue'),
          },
          {
            name: 'campaign-edit',
            path: 'edit', redirect: 'segment',
          },
          
          //{
          //  name: 'campaign-type',
          //  path: 'type', component: () => import(/* webpackChunkName: "campaign-type" */ '../views/domain/campaigns/Type.vue'),
          //},
          {
            name: 'campaign-segment',
            path: 'segment', component: () => import(/* webpackChunkName: "campaign-segment" */ '../views/domain/campaigns/Segment.vue'),
          },
          {
            name: 'campaign-setup-dynamic',
            path: 'setup-dynamic/:medium', redirect: to => { return { name: `campaign-setup-${to.params.medium}` } }
          },
          {
            name: 'campaign-setup-email',
            path: 'setup/mail', component: () => import(/* webpackChunkName: "campaign-setup-mail" */ '../views/domain/campaigns/email/Setup.vue'),
          },
          {
            name: 'campaign-design-dynamic',
            path: 'design-dynamic/:medium', redirect: to => { return { name: `campaign-design-${to.params.medium}` } }
          },
          {
            name: 'campaign-design-email',
            path: 'design/mail', component: () => import(/* webpackChunkName: "campaign-design-mail" */ '../views/domain/campaigns/email/Design.vue'),
          },
          {
            name: 'campaign-design-email-legacy',
            path: 'design/mail/legacy', component: () => import(/* webpackChunkName: "campaign-design-mail-legacy" */ '../views/domain/campaigns/email/DesignLegacy.vue'),
          },
          {
            name: 'campaign-design-email-variant',
            path: 'design/mail/variant/:variant', component: () => import(/* webpackChunkName: "campaign-design-mail" */ '../views/domain/campaigns/email/Design.vue'),
          },
          {
            name: 'campaign-summary-dynamic',
            path: 'summary-dynamic/:medium', redirect: to => { return { name: `campaign-summary-${to.params.medium}` } }
          },
          {
            name: 'campaign-summary-email',
            path: 'summary/mail', component: () => import(/* webpackChunkName: "campaign-summary-mail" */ '../views/domain/campaigns/email/Summary.vue'),
          }
        ]
      },
      {
        path: 'contacts', component: () => import(/* webpackChunkName: "contacts" */ '../views/domain/contacts/Index.vue'),
        children: [
          {
            name: 'contacts',
            path: '',
            component: () => import(/* webpackChunkName: "segment" */ '../views/domain/contacts/Segments.vue'),
            children: [
              { name: 'segment', 
                path: 'segments/:segment', 
                component: () => import(/* webpackChunkName: "segment" */ '../views/domain/contacts/Segment.vue')
              }
            ]
          },
          {
            name: 'contacts-c-import',
            path: 'contact-import/:segment?',
            component: () => import(/* webpackChunkName: "import-contacts" */ '../views/domain/contacts/ContactImport.vue')
          },
          {
            name: 'contacts-o-import',
            path: 'order-import/:segment?',
            component: () => import(/* webpackChunkName: "import-orders" */ '../views/domain/contacts/OrderImport.vue')
          },
          {
            name: 'contacts-unsubscribe',
            path: 'contacts-unsubscribe',
            component: () => import(/* webpackChunkName: "import-orders" */ '../views/domain/contacts/ContactUnsubscribe.vue')
          },
        ]
      },
      {
        name: 'forms',
        path: 'forms', component: () => import(/* webpackChunkName: "contacts" */ '../views/domain/forms/Index.vue'),
        children: [
          {
            name: 'add-form',
            path: 'add/:segment?',
            component: () => import(/* webpackChunkName: "add-form" */ '../views/domain/forms/Add.vue')
          },
          {
            name: 'form',
            path: ':form',
            component: () => import(/* webpackChunkName: "form" */ '../views/domain/forms/Edit.vue')
          }
        ]
      },
      {
        name: 'mailing',
        path: 'setup/mailing', component: () => import(/* webpackChunkName: "mailing" */ '../views/domain/Mailing.vue'),
      },
      {
        name: 'customizations',
        path: 'setup/customizations', component: () => import(/* webpackChunkName: "customizations" */ '../views/domain/Customizations.vue'),
      },
      {
        name: 'domain-access',
        path: 'access', component: () => import(/* webpackChunkName: "domain-access" */ '../views/domain/Access.vue'),
      },
      {
        //name: 'domain-stats',
        path: 'insights', component: () => import(/* webpackChunkName: "stats" */ '../views/domain/insights/Index.vue'),
        children: [
          {
            name: 'domain-schedule',
            path: '', component: () => import(/* webpackChunkName: "schedule" */ '../views/domain/insights/Schedule.vue'),
          },
          {
            name: 'domain-visitors',
            path: 'visitors', component: () => import(/* webpackChunkName: "visitors" */ '../views/domain/insights/Visitors.vue'),
          },
          {
            name: 'domain-products',
            path: 'products', component: () => import(/* webpackChunkName: "products" */ '../views/domain/insights/Products.vue'),
          },
          {
            name: 'visitor',
            path: 'visitors/:visitor',
            component: () => import(/* webpackChunkName: "visitor" */ '../views/domain/insights/Visitor.vue')
          },
        ]
      },
    ]
  },
  {
    name: 'newsletter-templates',
    path: '/newsletter-templates', component: () => import(/* webpackChunkName: "newsletter-templates" */ '../views/newsletter-template/List.vue')
  },
  {
    name: 'newsletter-template',
    path: '/newsletter-templates/:nstemplate', component: () => import(/* webpackChunkName: "newsletter-template" */ '../views/newsletter-template/Designer.vue'),
  },
  {
    name: 'helpdesk',
    path: '/helpdesk', component: () => import('../views/Helpdesk.vue'),
  },
  {
    name: 'running-campaigns',
    path: '/running-campaigns', component: () => import('../views/RunningCampaigns.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() { //(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
